import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import Chart from 'react-apexcharts'
import { Button, Text } from 'components/atoms'
import { TextWithLabel } from 'components/molecules'
import { useStoreDetail } from './hook'
import { ROUTE_HOME } from 'constant'
import Triagle from 'assets/images/triagle.png'

const StoreDetailLayout: FC<ReturnType<typeof useStoreDetail>> = ({
  optionsChart,
  series,
  dataText,
  positionPoint,
  params: { machineID, storeID, unitNo },
}) => {
  const navigate = useNavigate()

  return (
    <div className="w-full flex flex-col gap-6">
      <div className="flex flex-col items-center justify-start h-[54px]">
        <Text
          className="!font-bold text-lg leading-[27px] !text-nortextBtn"
          text="出玉傾向が似ているデータの中で"
        />
        <Text
          className="!font-bold text-lg leading-[27px] !text-nortextBtn"
          text={`最高に爆発した${Object.values(dataText).filter(i => i).length}パターンを発表`}
        />
      </div>
      <div className="w-full flex flex-col min-h-[602px] pb-7] bg-[rgba(0,0,0,0.8)] rounded-[32px]">
        <div className="flex items-center justify-center gap-[10px] w-full h-10 rounded-t-[30px] bg-divNeon bg-no-repeat bg-[length:100%_100%] font-lineSeed font-bold text-lg leading-6 text-black">
          出玉解析
          <div className="relative z-[1] min-w-[104px]">
            <TextWithLabel size={24} label="台番号" text={unitNo!} />
          </div>
        </div>
        <div className="relative w-full h-[307px] mt-[19px] mb-[6px] wide-in-left">
          <Chart
            type="area"
            options={optionsChart}
            series={series}
            height={'90%'}
          />
          <div className="absolute w-full h-full flex top-0 left-0">
            <div className="flex-1 h-full"></div>
            <div className="flex items-end justify-center flex-1 h-full font-notoSans font-semibold text-[16px] text-[#FFFFFF]">
              1時間後
            </div>
            <div className="flex items-end justify-center flex-1 h-full font-notoSans font-semibold text-[16px] text-[#FFFFFF]">
              2時間後
            </div>
            <div className="flex-1 h-full"></div>
          </div>
          <div className="absolute min-w-16 h-full flex top-0 left-[10%]">
            <div className="flex flex-col flex-1 h-full items-center">
              <div className="w-[2px] h-full border-[1px] border-dashed border-white shadow-borderPink" />
              <div className="flex flex-col items-center">
                <div className="w-3 h-3 rotate-180">
                  <img className="object-none" src={Triagle} alt="" />
                </div>
                <div className="font-notoSans font-bold text-[16px] text-[#FFFFFF] chart-text-shadow">
                  今現在
                </div>
              </div>
            </div>
          </div>
          <div className="absolute min-w-16 h-full flex top-0 right-[7%]">
            <div className="relative flex flex-col flex-1 h-full items-center">
              <div className="w-[2px] h-full border-[3px] border-solid border-white shadow-borderPink" />
              <div className="font-notoSans font-bold text-[16px] text-[#FFFFFF] chart-text-shadow">
                3時間後
              </div>
            </div>
          </div>
          <div className="absolute min-w-16 h-full top-0 right-[7%]">
            <div className="relative flex w-full h-[75%] top-[10%] justify-center items-center">
              {positionPoint.first && (
                <div
                  className="absolute w-[15px] h-[15px] rounded-[50%] bg-[#EE4444] border border-solid multiple-box-shadow"
                  style={{ bottom: `calc(${positionPoint.first}% - 7.5px)` }}
                />
              )}
              {positionPoint.second && (
                <div
                  className="absolute w-[15px] h-[15px] rounded-[50%] bg-[#5353FF] border border-solid multiple-box-shadow"
                  style={{ bottom: `calc(${positionPoint.second}% - 7.5px)` }}
                />
              )}
              {positionPoint.third && (
                <div
                  className="absolute w-[15px] h-[15px] rounded-[50%] bg-[#2ED7A1] border border-solid multiple-box-shadow"
                  style={{ bottom: `calc(${positionPoint.third}% - 7.5px)` }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="w-full px-4 min-h-[180px] flex">
          <div className="flex flex-1 px-4 pb-4 bg-border-neon bg-no-repeat bg-[length:100%_100%] items-end">
            <div className="w-full min-h-[129px] py-2 flex flex-col gap-[14px]">
              <Text
                className="flex items-center justify-center !font-bold !text-[17px] !text-[#FEFEFE] !leading-[21.76px]"
                text="3時間でここまで上向くかも"
              />
              <div className="flex flex-1 justify-evenly items-center">
                {dataText.fist && (
                  <div className="flex flex-col gap-[9px]">
                    <div className="w-full flex justify-center">
                      <div className="w-[15px] h-[15px] rounded-[50%] bg-[#EE4444] border border-solid multiple-box-shadow" />
                    </div>
                    <Text
                      className="!font-roboto !font-normal !text-[#FEFEFE] !text-lg !leading-[21.09px]  multiple-text-shadow"
                      text={`+${dataText.fist}`}
                    />
                  </div>
                )}
                {dataText.second && (
                  <div className="flex flex-col gap-[9px]">
                    <div className="w-full flex justify-center">
                      <div className="w-[15px] h-[15px] rounded-[50%] bg-[#5353FF] border border-solid multiple-box-shadow" />
                    </div>
                    <Text
                      className="!font-roboto !font-normal !text-[#FEFEFE] !text-lg !leading-[21.09px]  multiple-text-shadow"
                      text={`+${dataText.second}`}
                    />
                  </div>
                )}
                {dataText.third && (
                  <div className="flex flex-col gap-[9px]">
                    <div className="w-full flex justify-center">
                      <div className="w-[15px] h-[15px] rounded-[50%] bg-[#2ED7A1] border border-solid multiple-box-shadow" />
                    </div>
                    <Text
                      className="!font-roboto !font-normal !text-[#FEFEFE] !text-lg !leading-[21.09px]  multiple-text-shadow"
                      text={`+${dataText.third}`}
                    />
                  </div>
                )}
              </div>
              <Text
                className="flex items-center justify-center !font-normal !text-[10px] !text-[#FEFEFE] !leading-[12.8px]"
                text="※1時間5000玉を連続で打ち込んだと仮定した数値となります。"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-center mt-1">
        <div className="min-w-[144px]">
          <Button
            onClick={event => {
              event.preventDefault()
              navigate(
                `${ROUTE_HOME}?machine_id=${machineID}&store_id=${storeID}&unit_no=${unitNo}`,
              )
            }}
          >
            結果画面へもどる
          </Button>
        </div>
      </div>
    </div>
  )
}

export const StoreDetail = () => {
  return <StoreDetailLayout {...useStoreDetail()} />
}
